export default __webpack_public_path__ + "static/media/bubble-1.ca8fc9b1.png";